import React, { useState, useEffect } from 'react';

// third-party
import { IntlProvider, MessageFormatElement } from 'react-intl';
import useConfig from 'hooks/useConfig';

// load locales files
const loadLocaleData = (locale: string) => {
    switch (locale) {
        case 'fr':
            return import('utils/locales/fr.json');
        case 'ro':
            return import('utils/locales/ro.json');
        case 'zh':
            return import('utils/locales/zh.json');
        case 'he':
            return import('utils/locales/he.json');
        default:
            return import('utils/locales/en.json');
    }
};

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
    children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
    const { locale } = useConfig();
    const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

    const normalizeMessages = <T extends string | MessageFormatElement[]>(
    messages_arr: Record<string, T>
): Record<string, T> => {
    const result: Record<string, T> = {};

    Object.keys(messages_arr).forEach((key) => {
        result[key] = messages_arr[key];
        result[key.trim().toLowerCase()] = messages_arr[key];
    });

    return result;
};

// useEffect(() => {
//     loadLocaleData(locale).then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
//         if(d.default){
//             const normlized = normalizeMessages(d.default);
//             setMessages(normlized)
//         }else{
//             setMessages(undefined)
//         }
       
//     });
// }, [locale]);

    useEffect(() => {
        loadLocaleData(locale).then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
            setMessages(d.default);
        });
    }, [locale]);

    return (
        <>
            {messages && (
                <IntlProvider locale={locale} defaultLocale="en" onError={(err)=>{
                    }} messages={messages}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

export default Locales;
